module.exports = __webpack_public_path__ + "static/media/surprised-pikachu.8b022b20.png";